import { Button } from '@/components/Button/Button';

import type { TimeExtensionGroup } from './types';
import styles from './ExtensionGroupList.module.css';

interface ExtensionGroupListProps {
  groups: TimeExtensionGroup[];
  onEdit(index: number): void;
  onRemove(index: number): void;
}

export function formatExtensionDate(value: string): string {
  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return 'Invalid date';
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(parsed));
}

export function ExtensionGroupList({
  groups,
  onEdit,
  onRemove,
}: ExtensionGroupListProps) {
  if (groups.length === 0) {
    return (
      <p className={styles.empty}>
        No extension groups yet. Add one for DSP, late-add, travel, or other
        approved student groups.
      </p>
    );
  }

  return (
    <div className={styles.list}>
      {groups.map((group, index) => (
        <div className={styles.row} key={`${group.displayName}-${index}`}>
          <div className={styles.details}>
            <span className={styles.name}>
              {group.displayName || 'Untitled extension group'}
            </span>
            <span className={styles.date}>
              Extends to {formatExtensionDate(group.endTimeUtcMilli)}
            </span>
            <span className={styles.meta}>
              {group.hashedStudentIds.length} student
              {group.hashedStudentIds.length === 1 ? '' : 's'}
            </span>
          </div>
          <div className={styles.actions}>
            <Button
              aria-label={`Edit ${group.displayName || 'extension group'}`}
              onClick={() => onEdit(index)}
              size="small"
              variant="secondary"
            >
              Edit
            </Button>
            <Button
              aria-label={`Remove ${group.displayName || 'extension group'}`}
              destructive
              onClick={() => onRemove(index)}
              size="small"
              variant="ghost"
            >
              Remove
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
